import { mapState, mapActions, mapGetters } from 'vuex';

import MachineDrawerEditor from './MachineDrawerEditor.vue';

const machineDrawersHeaders = Object.freeze([
  { text: 'Name', value: 'name' },
  { text: 'Internal Name', value: 'internalName' },
  { text: 'Capacity', value: 'capacity' },
  { text: 'Substrate', value: 'preferredSubstrate' },
  { text: 'Substrate Height', value: 'preferredSubstrateHeight' },
  { text: 'Substrate Width', value: 'preferredSubstrateWidth' },
  { text: 'State', value: 'state' },
  { text: '', value: 'actions', width: '5%' },
]);

export default {
  name: 'MachineDrawers',
  props: {
    machineName: {
      type: String,
      default: '',
    },
  },
  components: {
    MachineDrawerEditor,
  },
  data() {
    return {
      dialog: false,
      showEditor: false,
      isEditorCreateMode: true,
      editedDrawer: {},
      machineDrawersHeaders,
    };
  },
  computed: {
    ...mapState('machines', ['machineDrawers']),
    ...mapState('locations', ['suffix']),
    ...mapGetters('enums', ['machineDrawerStateEnumByKey']),
    disableOpenDrawerCreatorBtn() {
      return this.showEditor && this.isEditorCreateMode;
    },
  },
  methods: {
    ...mapActions('machines', ['getMachineDrawers']),
    async showDrawersModal() {
      this.$VBlackerTheme.openLoadingSpinner();
      try {
        await this.getMachineDrawers({ machineName: this.machineName });
        if (!this.machineDrawers.length) {
          this.showEditor = true;
        }
        this.dialog = true;
      } catch (e) {
        this.$VBlackerTheme.notification.error(e);
      } finally {
        this.$VBlackerTheme.closeLoadingSpinner();
      }
    },
    async onDrawerEditorSuccess() {
      try {
        await this.getMachineDrawers({ machineName: this.machineName });
      } catch (e) {
        this.$VBlackerTheme.notification.error(e);
      } finally {
        this.$VBlackerTheme.closeLoadingSpinner();
      }
    },
    setEditedDrawer(drawer) {
      this.editedDrawer = drawer;
      this.isEditorCreateMode = false;
      this.showEditor = true;
    },
    openDrawerCreateForm() {
      this.isEditorCreateMode = true;
      this.showEditor = true;
    },
  },
};
